/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const archiveScheduleBodyExpectedVersionExclusiveMin = 0;
export const archiveScheduleBodyExpectedVersionMax = 9007199254740991;

export const archiveScheduleBodyPreviewFingerprintMax = 256;

export const ArchiveScheduleBody = zod.object({
  expectedVersion: zod
    .int()
    .gt(archiveScheduleBodyExpectedVersionExclusiveMin)
    .max(archiveScheduleBodyExpectedVersionMax),
  previewFingerprint: zod.string().min(1).max(archiveScheduleBodyPreviewFingerprintMax),
  confirmed: zod.literal(true),
});

export type ArchiveScheduleBody = zod.input<typeof ArchiveScheduleBody>;
export type ArchiveScheduleBodyOutput = zod.output<typeof ArchiveScheduleBody>;
